// Masterminds (docs/mastermind-admin-plan.md 3): owner and admin, at 2-step login. By address:
//   /admin/masterminds                              with 1 mastermind in the hub, its members (a replace,
//                                                   so Back doesn't loop); with more, 1 card each
//   /admin/masterminds/<slug>                       its members, group by group (?group, ?show, ?left)
//   /admin/masterminds/<slug>/<person id>           the member view, This month (?group and ?show ride along)
//   /admin/masterminds/<slug>/<person id>/log       the member view, Accountability log (?copy=<id>)
// The slug is checked against a catalogue row of type mastermind that's moved in; anything else gives
// "nothing here". Every mastermind shows here by its type, never by its slug.
import { useEffect } from 'react'
import { Link, navigate, useLocation } from '../../lib/router.jsx'
import { Card, Crumbs, Loading, PageHeader, Problem, adminPath, useLoad } from '../ui/index.js'
import { MM } from '../mastermind/words.js'
import { loadMasterminds, loadMembers } from '../mastermind/data.js'
import { memberRow } from '../mastermind/section.js'
import { Members } from '../mastermind/Members.jsx'
import { MemberView } from '../mastermind/Member.jsx'
import '../../styles/admin-masterminds.css'

function Pick({ products, api }) {
  const counts = useLoad(() => Promise.all(products.map(p => loadMembers(api, p.id).catch(() => []))), [api, products.map(p => p.id).join()])
  return (
    <>
      <PageHeader eyebrow={MM.eyebrow} title={MM.nav} lede={MM.lede} />
      <div className="amx-pick">
        {products.map((p, i) => {
          const rows = (counts.data?.[i] || []).map(m => memberRow(m))
          const groups = new Set(rows.map(r => r.cohortId).filter(Boolean)).size
          return (
            <Card key={p.id} title={p.name}>
              <p className="ad-lede">{counts.data ? MM.pick({ name: p.name, groups, members: rows.length, review: rows.filter(r => r.review).length }) : MM.loading}</p>
              <p><Link className="ad-btn ad-btn--line ad-btn--sm" to={adminPath.mastermind(p.slug)}>{MM.open}</Link></p>
            </Card>
          )
        })}
      </div>
    </>
  )
}

export default function Masterminds({ role, route, api }) {
  const { query } = useLocation()
  const { slug, person, tab } = route.params
  const list = useLoad(() => loadMasterminds(api), [api])
  const products = list.data || []
  const only = !slug && products.length === 1 ? products[0] : null
  // /admin/masterminds alone opens the only mastermind. Only while that address is still the one showing: on the way
  // to another screen this one can draw once more with no slug, and sending it back here trapped Adam on Masterminds
  // (18 Oct)
  useEffect(() => {
    if (!only) return
    if (window.location.pathname.replace(/\/+$/, '') !== '/admin/masterminds') return
    navigate(adminPath.mastermind(only.slug), { replace: true })
  }, [only, slug, route.screen])

  if (list.status === 'loading' && !list.data) return <Loading />
  if (!list.data) return <Problem error={list.error} onRetry={list.reload} />
  if (!slug) {
    if (only) return <Loading />
    if (!products.length) {
      return (
        <>
          <PageHeader eyebrow={MM.eyebrow} title={MM.nav} lede={MM.lede} />
          <Card><p className="ad-lede">{MM.noneYet}</p></Card>
        </>
      )
    }
    return <Pick products={products} api={api} />
  }
  const product = products.find(p => p.slug === slug)
  if (!product) {
    return (
      <>
        <Crumbs items={[{ label: MM.eyebrow, to: adminPath.masterminds() }, { label: MM.nothingHere }]} />
        <PageHeader eyebrow={MM.eyebrow} title={MM.nothingHere} />
        <Card><p className="ad-lede">{MM.nothingLine}</p><p><Link to={adminPath.masterminds()}>{MM.back}</Link></p></Card>
      </>
    )
  }
  if (person) return <MemberView key={product.id} product={product} personId={person} tab={tab} role={role} query={query} />
  return <Members product={product} role={role} query={query} />
}
